import { useAppContext } from "./useAppContext";
import { detect } from "../services/detect";
import { useState } from "react";
import type { ISO639_1_Language } from "@shared/types";
import { handleErrorMessage } from "../lib/utils";

export function useDetect() {
	const { setDetectResult } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);

	const detectAI = async (text: string, language: ISO639_1_Language = "en") => {
		if (!text.trim()) {
			return;
		}

		setIsLoading(true);

		return detect({ text, language })
			.then((result) => setDetectResult(result))
			.catch((error) => {
				handleErrorMessage(error, "Error detecting AI content");
				throw error;
			})
			.finally(() => setIsLoading(false));
	};

	return { detectAI, isLoading };
}
